import React, { useState } from 'react';
import { CountdownTimer } from './components/ui/CountdownTimer';
import { Hero } from './components/sections/Hero';
import { StorySections } from './components/sections/StorySections';
import { ValueStack } from './components/sections/ValueStack';
import { Pricing } from './components/sections/Pricing';
import { FAQ } from './components/sections/FAQ';
import { Footer } from './components/sections/Footer';
import { SocialProofPopup } from './components/ui/SocialProofPopup';
import { UpsellPage } from './components/sections/UpsellPage';
export function App() {
  const [showUpsell, setShowUpsell] = useState(false);
  const handleBuyClick = () => {
    setShowUpsell(true);
  };
  const handleUpsellAccept = () => {
    setShowUpsell(false);
    // Redirect to checkout with upsell
    alert('Redirigiendo...');
    window.location.href = 'https://didactiadigital.com/cart/42970454491184:1';
  };
  const handleUpsellDecline = () => {
    setShowUpsell(false);
    // Redirect to checkout without upsell
    window.location.href = 'https://didactiadigital.com/cart/42966321299504:1';
  };
  return <div className="min-h-screen flex flex-col font-sans" data-id="element-0">
      {/* URGENCY BAR (Sticky Top) */}
      <div className="sticky top-0 z-50 bg-chocolate text-cream py-3 px-4 shadow-md" data-id="element-1">
        <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center justify-center gap-2 md:gap-6 text-center md:text-left text-sm md:text-base" data-id="element-2">
          <p className="font-medium" data-id="element-3">
            <span className="text-gold font-bold" data-id="element-4">PROMO DE LANZAMIENTO:</span>{' '}
            Obtén los 8 Ebooks del programa 'Repostería Emprendedora' con el 92%
            de descuento.
          </p>
          <div className="bg-rose-600/20 px-3 py-1 rounded-full border border-rose-500/30" data-id="element-5">
            <CountdownTimer className="text-rose-400" data-id="element-6" />
          </div>
        </div>
      </div>

      <main data-id="element-7">
        <Hero onBuyClick={handleBuyClick} data-id="element-8" />
        <StorySections data-id="element-9" />
        <ValueStack data-id="element-10" />
        <Pricing onBuyClick={handleBuyClick} data-id="element-11" />
        <FAQ data-id="element-12" />
      </main>

      <Footer onBuyClick={handleBuyClick} data-id="element-13" />
      <SocialProofPopup data-id="element-14" />
      <UpsellPage isOpen={showUpsell} onAccept={handleUpsellAccept} onDecline={handleUpsellDecline} data-id="element-15" />
    </div>;
}